/**
 * 複数件の値を一覧セルに収める表示。
 * 先頭の1件だけを出し、残りは「その他N件」にまとめる。
 * 全件はレコード詳細ポップアップとエクスポートで確認できる。
 *
 * items は必ず配列で渡す。表示用のカンマ結合文字列を割って数えると、
 * 値自体に「, 」を含む成果物名（例: 「要件説明資料, WBS(RFXがある場合のみ)」）を
 * 2件と誤認するため、件数は構造化データから数える。
 *
 * 一覧の行は高さ53px固定（仮想スクロールのため）でセルは overflow: hidden なので、
 * 先頭の値が長いと折り返した先の「その他N件」が切れて見えなくなる。
 * 「あと何件あるか」は値そのものより先に伝わるべき情報なので、件数は縮まない要素とし、
 * 先頭の値だけを1行に省略記号で丸める。丸めた全文は title で確認できる。
 *
 * asLink を付けると先頭要素をリンクにする（成果物保管URLなど）。
 * 結合文字列をそのまま href にすると複数件でリンクが壊れるため、URL 列は必ずこれを通す。
 */
export default function JoinedSummaryCell({ items, asLink = false }) {
  const values = (Array.isArray(items) ? items : []).filter(Boolean);
  if (values.length === 0) return null;

  const [first, ...rest] = values;
  return (
    <span
      style={{
        display: 'flex', alignItems: 'baseline', gap: '4px',
        minWidth: 0, maxWidth: '100%', fontSize: '13px', color: '#101828',
      }}
    >
      <span
        title={first}
        style={{
          flex: '1 1 auto', minWidth: 0,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}
      >
        {asLink ? (
          <a
            href={first}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ color: '#2563eb', textDecoration: 'underline' }}
          >
            {first}
          </a>
        ) : first}
      </span>
      {rest.length > 0 && (
        <span
          title={rest.join('\n')}
          style={{ flex: '0 0 auto', color: '#6b7280', fontSize: '11px', whiteSpace: 'nowrap' }}
        >
          その他{rest.length}件
        </span>
      )}
    </span>
  );
}
